import { Services } from './user-service';
import config from './api-config';
import router from '@/router';
import store from '@/store';

export default class AuthService {
    public token: string = '';

    private service = new Services();

    constructor() {
        if (localStorage[config.token] !== "undefined"){
            this.token = JSON.parse(localStorage[config.token] || null);
        }

        else {
            this.token = null;
        }
    }

    public async login(username: string, password: string) {
        const response = await this.service.loginUser(username, password)
            .then((entity) => {
                const data = entity.data; 
                if (data !== null) {
                    localStorage[config.token] = JSON.stringify(data.token);
                    localStorage[config.currentUser] = JSON.stringify(data.username);
                    localStorage[config.currentUsername] = username;
                    localStorage[config.currentPassword] = password;
                    localStorage[config.customerData] = JSON.stringify(data.customersWithPlants);
                    localStorage[config.userRole] = JSON.stringify(data.roles);
                }
                // document.location.reload();
                if (data.customersWithPlants.length > 1){
                    router.push('/');
                } else  {
                    router.push('/dashboard');
                }
            })
            .catch((err) => {
                return 'failed';
            });
        return response;
    }

    public logout() {
        localStorage[config.token] = null;
        localStorage[config.currentUser] = null;
        localStorage[config.customerData] = null;
        localStorage[config.currentPlant] = null;
        localStorage[config.userRole] = null;

        document.location.reload();
        router.push('/');
    }

    public isAuthenticated() {
        return this.token !== null;
    }
}
